import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

// Styles
import styles from "./contact-us-problem-with-product-guarantees.module.scss";

export function GuaranteeAndProtectPlusContent() {
  return (
    <div className={styles.guarantees__section}>
      <div className={styles.guaranteeQueries}>
        <h4>Guarantee queries</h4>
        <p>
          Find out more about our <a href="https://www.johnlewis.com/customer-services/guarantees">guarantees</a>.
        </p>
      </div>
      <div className={styles.protectPlus}>
        <h4>Protect Plus queries</h4>
        <p className={styles.protectPlus}>
          Find out more about <a href="https://www.johnlewis.com/our-services/protect-plus">Protect Plus</a>, our
          Accidental Damage insurance
        </p>
      </div>
    </div>
  );
}

function ContactUsProblemWithProductGuarantees({ solution: { id, title }, className }) {
  return (
    <article className={classnames(styles.standardSolution, className)} data-solution-id={id}>
      <h2 className={styles.standardSolution__top}>Did you know...</h2>
      <div className={styles.standardSolution__inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        <GuaranteeAndProtectPlusContent />
      </div>
    </article>
  );
}

ContactUsProblemWithProductGuarantees.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    buttonType: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
  contactMethods: PropTypes.shape({
    liveChat: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, pct: PropTypes.number })]),
    ),
  }),
};

ContactUsProblemWithProductGuarantees.defaultProps = {
  className: undefined,
  contactMethods: {},
};

export default ContactUsProblemWithProductGuarantees;
